<template>
  <el-dialog title="新增客户" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="客户性质:" prop="profession">
        <el-select v-model="data.customerNature" placeholder="请选择客户性质" clearable style="width:100%">
          <el-option v-for="dict in natureOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="客户类型:" prop="customerType">
        <el-select v-model="data.customerType" placeholder="请选择客户类型" clearable style="width:100%">
          <el-option v-for="dict in customerTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="客户名称:" prop="customerName">
        <CompanyInput v-model="data.customerName" :company-id="data.companyId" @change="handleCompanyChange"/>
      </el-form-item>
      <el-form-item label="客户来源:" prop="source">
        <el-select v-model="data.source" placeholder="请选择客户来源" allow-create filterable clearable style="width:100%">
          <el-option v-for="dict in sourceOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="客户级别:" prop="customerLevel">
        <el-select v-model="data.customerLevel" placeholder="请选择客户级别" clearable style="width:100%">
          <el-option v-for="dict in customerLevelOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人:" prop="managerId">
        <UserSelect v-model="data.managerId" placeholder="请选择负责人"></UserSelect>
      </el-form-item>
      <el-divider content-position="left">首个联系人</el-divider>
      <el-form-item label="联系人:" prop="contact.name">
        <el-input v-model="data.contact.name" :maxlength="32" placeholder="请输入联系人姓名" clearable/>
      </el-form-item>
      <el-form-item label="手机号:" prop="contact.mobile">
        <el-input v-model="data.contact.mobile" placeholder="请输入联系人手机号" clearable/>
      </el-form-item>
      <el-form-item label="部门:" prop="contact.apartment">
        <el-input v-model="data.contact.apartment" :maxlength="32" placeholder="请输入部门" clearable/>
      </el-form-item>
      <el-form-item label="职务:" prop="contact.position">
        <el-input v-model="data.contact.position" :maxlength="32" placeholder="请输入职务" clearable/>
      </el-form-item>
      <!-- <el-form-item label="行业:" prop="profession">
        <el-select v-model="data.profession" placeholder="请选择行业" clearable style="width:100%">
          <el-option v-for="dict in professionOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item> -->
      <el-form-item label="所在区域" prop="area">
        <el-cascader v-model="data.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址:" prop="address">
        <el-input v-model="data.address" :maxlength="255" placeholder="请输入详细地址" clearable/>
      </el-form-item>
      <el-form-item label="公司网址:" prop="url">
        <el-input v-model="data.url" :maxlength="255" placeholder="请输入公司网址" clearable/>
      </el-form-item>
      <!-- <el-form-item label="公司总人数:" prop="employeeNo">
        <el-input-number v-model="data.employeeNo" placeholder="请输入公司总人数" :min="0" :max="9999999" :controls="false" clearable class="crm-input-number-wrap"/>
      </el-form-item> -->
      <el-form-item label="备注:" prop="remark">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="1000" show-word-limit v-model="data.remark" placeholder="请输入备注" clearable/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {createCustomerWithContact, queryCustomerByName} from "@/api/crm/customer";
import {listAllLevelArea} from "@/api/crm/area";
import UserSelect from "@/views/crm/components/userSelect";
import CompanyInput from "@/views/crm/components/companyInput";
import { mapState } from 'vuex'
import {transferCascaderOptionsForProvince} from "@/utils";
import {validUrl} from "@/utils/validator";
import {isPhone} from "@/utils/validate";

export default {
  name: "AddCustomerDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      sourceOptions: [],
      customerLevelOptions: [],
      natureOptions: [], // 客户性质
      professionOptions: [],
      customerTypeOptions: [],
      areaOptions: [],
      rules: {
        customerType: [
          {required: true, message: '请选择客户类型', trigger: 'change'}
        ],
        customerName: [
          {required: true, validator: this.checkCustomerName, trigger: 'change'}
        ],
        source: [
          {required: true, message: '请选择客户来源', trigger: 'change'}
        ],
        customerLevel: [
          {required: true, message: '请选择客户级别', trigger: 'change'}
        ],
        area: [
          {required: true, message: '请选择所在区域', trigger: 'change'}
        ],
        managerId: [
          {required: true, type: 'number', message: '请选择负责人', trigger: 'change'}
        ],
        'contact.name': [
          {required: true, message: '请输入联系人姓名', trigger: 'change'}
        ],
        'contact.mobile': [
          {required: true, message: '请输入联系人手机号', trigger: 'change'},
          {validator: this.checkMobile, trigger: 'blur'}
        ]
      },
      data: {
        customerName: "",
        customerType: null,
        customerNature: null,
        companyId: null,
        source: null,
        customerLevel: null,
        managerId: null,
        profession: null,
        area: [],
        address: "",
        url: "",
        employeeNo: undefined,
        remark: "",
        contact: {
          name: null,
          mobile: null,
          apartment: null,
          position: null
        }
      }
    };
  },
  created() {
    this.getDicts("common_source").then(response => {
      this.sourceOptions = response.data;
    });
    this.getDicts("sys_customer_level").then(response => {
      this.customerLevelOptions = response.data;
    });
    this.getDicts("sys_customer_type").then(response => {
      this.customerTypeOptions = response.data;
    });
    this.getDicts("profession").then(response => {
      this.professionOptions = response.data;
    });
    this.getDicts("customer_nature").then(response => {
      this.natureOptions = response.data;
    });

    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    CompanyInput
  },
  watch: {
    visible (val) {
      if (!val) {
        this.data.companyId = null;
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open () {
      this.data.managerId = this.currentUserId;
      this.visible = true
    },
    handleCompanyChange(companyName, companyId) {
      this.data.companyId = companyId ? companyId : ''
    },
    checkMobile (rule, value, callback) {
      if (!value) {
        callback(new Error("请输入联系人手机号"))
      } else if (isPhone(value)) {
        callback()
      } else {
        callback(new Error("格式不正确"))
      }
    },
    checkCustomerName (rule, value, callback) {
      if (!value) {
        callback(new Error("请输入客户名称"))
      } else {
        queryCustomerByName(
          {
            customerName: value
          }
        ).then( response => {
          if (response.data && response.data.id) {
            var statusStr=response.data.status==0?'有效':'失效';
            callback("客户名称已存在，状态为"+statusStr+"，请重新输入")
          } else {
            callback()
          }
        }).catch(error => {
          callback()
        })
      }
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.data.provinceCode = this.data.area && this.data.area.length > 0 ? this.data.area[0] : null
          this.data.cityCode = this.data.area && this.data.area.length > 1 ? this.data.area[1] : null
          this.data.regionCode = this.data.area && this.data.area.length > 2 ? this.data.area[2] : null
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          const submitData = JSON.parse(JSON.stringify(this.data))
          submitData.contact.managerId = submitData.managerId
          submitData.contact.mobile = submitData.contact.mobile ? submitData.contact.mobile.replace(/\s/g, '') : submitData.contact.mobile
          createCustomerWithContact(submitData).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("客户新增成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
